import React, { useEffect } from 'react';
import { FormContextValues } from 'react-hook-form';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import {
  PERSONAL_INFO_FORM_FIELD_LABELS,
  ADDRESS_FORM_FIELD_LABELS,
  PAC_FORM_FIELD_LABELS,
  PEP_FORM_FIELD_LABELS,
  PersonalInfoProps,
  AddressProps,
  PACProps,
  PEPProps,
} from 'shared/constants/ekyc';
import Button from 'shared/modules/common/components/atoms/Button';
import TextInput from 'shared/modules/common/components/atoms/TextInput';
type Props = {
  onNextButtonPress: () => void;
  onReturnButtonPress: () => void;
  personalInfoForm: FormContextValues<PersonalInfoProps>;
  addressForm: FormContextValues<AddressProps>;
  pacForm: FormContextValues<PACProps>;
  pepForm: FormContextValues<PEPProps>;
  onFocus?: () => void;
  onBlur?: () => void;
};

const Confirmation = (props: Props) => {
  const {
    onNextButtonPress,
    onReturnButtonPress,
    personalInfoForm,
    addressForm,
    pacForm,
    pepForm,
    onFocus,
    onBlur,
  } = props;
  const isBigScreen = useMediaQuery({ minWidth: 768 });

  useEffect(() => {
    onFocus?.();

    return () => onBlur?.();
  }, []);

  return (
    <View>
      <View style={styles.panel}>
        <Text
          style={styles.notifTitle}
        >{`自動入力された情報をご確認ください`}</Text>
        <Text style={styles.notifBody}>
          {`身分証明書と完全に一致する情報を入力してください。情報が一致しない場合、本人確認ができません。`}
        </Text>
      </View>
      <View style={styles.panel}>
        <View
          style={styles.form}
          {...Platform.select({ web: { accessibilityRole: 'form' } })}
        >
          {Object.keys(personalInfoForm.getValues()).map((field, index) => (
            <TextInput
              key={index}
              value={personalInfoForm.getValues(field)}
              label={PERSONAL_INFO_FORM_FIELD_LABELS[index]}
              editable={false}
              style={
                Object.keys(personalInfoForm.getValues()).length - 1 !== index
                  ? styles.textInput
                  : {}
              }
              inputStyle={styles.textInputNativeInput}
            />
          ))}
        </View>
      </View>

      <View style={styles.panel}>
        <View
          style={styles.form}
          {...Platform.select({ web: { accessibilityRole: 'form' } })}
        >
          {Object.keys(addressForm.getValues()).map((field, index) => (
            <TextInput
              key={index}
              value={addressForm.getValues(field)}
              label={ADDRESS_FORM_FIELD_LABELS[index]}
              editable={false}
              style={
                Object.keys(addressForm.getValues()).length - 1 !== index
                  ? styles.textInput
                  : {}
              }
              inputStyle={styles.textInputNativeInput}
            />
          ))}
        </View>
      </View>

      <View style={styles.panel}>
        <View
          style={styles.form}
          {...Platform.select({ web: { accessibilityRole: 'form' } })}
        >
          {Object.keys(pacForm.getValues()).map((field, index) => (
            <TextInput
              key={index}
              value={pacForm.getValues(field)}
              label={PAC_FORM_FIELD_LABELS[index]}
              editable={false}
              style={
                Object.keys(pacForm.getValues()).length - 1 !== index
                  ? styles.textInput
                  : {}
              }
              inputStyle={styles.textInputNativeInput}
            />
          ))}
        </View>
      </View>

      <View style={styles.panel}>
        <View
          style={styles.form}
          {...Platform.select({ web: { accessibilityRole: 'form' } })}
        >
          {Object.keys(pepForm.getValues()).map((field, index) => (
            <TextInput
              key={index}
              value={pepForm.getValues(field)}
              label={PEP_FORM_FIELD_LABELS[index]}
              editable={false}
              style={
                Object.keys(pepForm.getValues()).length - 1 !== index
                  ? styles.textInput
                  : {}
              }
              inputStyle={styles.textInputNativeInput}
            />
          ))}
        </View>
      </View>

      <View
        style={[
          styles.buttonContainer,
          isBigScreen && styles.buttonContainerBigScreen,
        ]}
      >
        <Button
          title="送信する"
          onPress={onNextButtonPress}
          id="ekyc-confirmation-form-next-button"
        />
        <Button
          title="会員情報入力へ戻る"
          variant="outlined"
          onPress={onReturnButtonPress}
          id="ekyc-confirmation-form-return-button"
          style={styles.buttonReturn}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  panel: {
    padding: 24,
    borderRadius: 16,
    backgroundColor: '#fff',
    marginVertical: 12,
  },
  notifTitle: {
    fontSize: 14,
    color: '#FF2751',
    fontWeight: '600',
    marginBottom: 16,
  },
  notifBody: {
    fontSize: 12,
    color: '#1C1C1C',
  },
  form: {
    flex: 1,
    justifyContent: 'space-between',
  },
  textInput: {
    marginBottom: 12,
  },
  textInputNativeInput: {
    color: '#2A2E32',
  },
  buttonContainer: {
    flex: 1,
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 12,
  },
  buttonContainerBigScreen: {
    paddingTop: 48,
  },
  buttonReturn: {
    marginTop: 18,
  },
});

export default Confirmation;
